<template lang='pug'>
v-jumbotron
  v-container(fill-height)
    v-layout(align-center)
      v-flex
        v-alert(
          :value='errors.has("common")'
          color='error'
          icon='warning'
          class='mb-3'
          outline
        ) {{ errors.first("common") }}
        h3(class="display-3") Подтверждение адреса элпочты
        span(class="subheading") Кто-то, возможны не вы бла-бла-бла
        v-divider(class='my-3')
        v-layout
          v-spacer
          v-btn(large flat @click='$router.push({ name: "Index" })')
            v-icon(left) keyboard_backspace
            span Вернуться на главную
          v-btn(large color='primary' :loading='loading' @click='tryConfirm')
            | Подтвердить
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: String
    }
  },

  data: () => ({
    loading: false
  }),

  methods: {
    tryConfirm() {
      this.loading = true

      this.confirm({
        confirm_hash: this.id
      })
        .then(() => {
          this.$router.push({
            name: 'Index'
          })
        })
        .catch(error => {
          this.$setErrors(error.response)
        })
    },

    ...mapActions('auth', ['confirm'])
  }
}
</script>
